import Element from './element'

export default class CardYearElement extends Element {
  static elementClassName = 'CardYearElement'
}
